module.exports = __webpack_public_path__ + "img/thanks.3d0ec0e9.png";